import React, { FC } from 'react';
import { SystemButtonHyperlinkProps } from '../button.types';
import { Hyperlink } from '../../Hyperlink';
import { SystemHyperlinkDefault } from '../systemButtonDefaultProps';
import { SystemButtonContent } from '../SystemButton';
import styles from './primary_button.module.scss';

type Props = {
  iconLeft?: string;
  iconRight?: string;
} & SystemButtonHyperlinkProps;

export const PrimaryHyperlink: FC<Props> = ({
  children,
  target,
  href,
  rel,
  source,
  iconLeft,
  iconRight,
  onClick,
}) => {
  return (
    <Hyperlink
      className={styles.primary}
      target={target}
      href={href}
      rel={rel}
      source={source}
      onClick={onClick}
    >
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        {children}
      </SystemButtonContent>
    </Hyperlink>
  );
};

PrimaryHyperlink.defaultProps = SystemHyperlinkDefault;
